import { connect } from 'react-redux';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
import { getAssignedResponderInWidget } from '../../responders/selectors/getAssignedResponderInWidget';
import { clickedMeetingsLink } from '../../actions/MeetingsActions/clickedMeetingsLink';
import MeetingsLinkButton from '../components/MeetingsLinkButton';
import { shouldShowMeetingsLink } from '../selectors/shouldShowMeetingsLink';
const mapStateToProps = state => {
  return {
    assignedResponder: getAssignedResponderInWidget(state),
    shouldShowMeetingsLink: shouldShowMeetingsLink(state),
    widgetData: getLatestWidgetData(state)
  };
};
const mapDispatchToProps = {
  clickedMeetingsLink
};
export default connect(mapStateToProps, mapDispatchToProps)(MeetingsLinkButton);